export const ErrorCode = {
  // 기본 오류
  1000: 'GENERAL',
  1001: 'BAD_REQUEST',
  1002: 'INVALID_PARAMETER',
  1003: 'ALREADY_PROCESSED_REQUEST',
  1004: 'TIMEOUT',
  1005: 'PLAYER_NOT_FOUND',

  // 인증 관련
  1010: 'INVALID_ID_OR_PASSWORD',
  1011: 'INVALID_SESSION',
  1012: 'LOGIN_FAILED_ALREADY_LOGGED_IN',
  1013: 'LOGOUT_FAILED_NOT_LOGGED_IN',
  1014: 'NO_AVAILABLE_GUEST_ACCOUNT',
  1015: 'PLAYER_BLOCKED',
  1016: 'INVALID_LOGIN_TOKEN',
  1017: 'KICK_FAILED_NOT_LOGGED_IN',

  // 권한 관련
  1099: 'UNAUTHORIZED',
  1100: 'INVALID_TOKEN',

  // 자산 관리
  2000: 'INSUFFICIENT_ASSET',
  2001: 'INSUFFICIENT_BALANCE',
  2002: 'ALREADY_CREATED_ASSET',

  // 게임 서버
  3000: 'GAME_SERVER_ERROR',
  3001: 'GAME_SERVER_NO_RESPONSE',

  // 게임 플레이
  4000: 'GAME_PLAY_NOT_AVAILABLE',
  4010: 'GAME_CANCELED',

  // 리플레이
  5000: 'REPLAY_NOT_AVAILABLE',

  // 플랫폼
  6000: 'PLATFORM_ERROR',
  6001: 'PLATFORM_CONFIG_ERROR',
  6002: 'NOT_PLATFORM_PLAYER',

  // 통합 API
  7000: 'INTEGRATION_API_ERROR',
  7001: 'INTEGRATION_CONFIG_ERROR',
  7002: 'INTEGRATION_OPERATION_ERROR',
  7003: 'INTEGRATION_AGGREGATOR_ERROR',

  // 알 수 없음
  9999: 'UNKNOWN'
} as const;

// 타입 정의
export type ErrorCodeType = (typeof ErrorCode)[keyof typeof ErrorCode];
export type ErrorCodeKey = keyof typeof ErrorCode;

// 에러 코드 카테고리별 타입
export type BasicErrorCode = 1000 | 1001 | 1002 | 1003 | 1004 | 1005;
export type AuthErrorCode = 1010 | 1011 | 1012 | 1013 | 1014 | 1015 | 1016 | 1017;
export type PermissionErrorCode = 1099 | 1100;
export type AssetErrorCode = 2000 | 2001 | 2002;
export type GameServerErrorCode = 3000 | 3001;
export type GamePlayErrorCode = 4000 | 4010;
export type ReplayErrorCode = 5000;
export type PlatformErrorCode = 6000 | 6001 | 6002;
export type IntegrationErrorCode = 7000 | 7001 | 7002 | 7003;
export type UnknownErrorCode = 9999;

// 모든 에러 코드 유니온 타입
export type AllErrorCode =
  | BasicErrorCode
  | AuthErrorCode
  | PermissionErrorCode
  | AssetErrorCode
  | GameServerErrorCode
  | GamePlayErrorCode
  | ReplayErrorCode
  | PlatformErrorCode
  | IntegrationErrorCode
  | UnknownErrorCode;

// 유틸리티 함수들
export const getErrorCodeName = (code: AllErrorCode): string => {
  return ErrorCode[code] || 'UNKNOWN';
};

export const isErrorCode = (code: number): code is AllErrorCode => {
  return code in ErrorCode;
};

// 카테고리 구분은 사용하지 않으므로 제거됨
